"use client";

// src/context/react/ThreadViewportContext.ts
import { createContext } from "react";
import { createContextHook } from "./utils/createContextHook.js";
import { createContextStoreHook } from "./utils/createContextStoreHook.js";
var ThreadViewportContext = createContext(null);
var useThreadViewportContext = createContextHook(
  ThreadViewportContext,
  "ThreadPrimitive.Viewport"
);
var { useThreadViewport, useThreadViewportStore } = createContextStoreHook(useThreadViewportContext, "useThreadViewport");
export {
  ThreadViewportContext,
  useThreadViewport,
  useThreadViewportStore
};
//# sourceMappingURL=ThreadViewportContext.js.map